<template>
  <div>
    <b-table
      class="sticky-table-header"
      :data="purchasesInvoices"
      hoverable
      @click="showDetails"
    >
      <b-table-column field="invoice.emission" label="Emissão" v-slot="props">
        <span class="adjust-top">
          {{
            moment
              .utc(props.row.invoice.emission)
              .add(preferences.timezone, "h")
              .format("DD/MM/YY HH:mm:ss")
          }}
        </span>
      </b-table-column>

      <b-table-column
        field="invoice.buyerInfo.companyName"
        label="Comprador"
        v-slot="props"
        :visible="showBuyer"
      >
        <span class="adjust-top">
          {{ props.row.invoice.buyerInfo.companyName }}
        </span>
      </b-table-column>

      <b-table-column
        field="invoice.sellerInfo.companyName"
        label="Fornecedor"
        v-slot="props"
      >
        <span class="adjust-top">
          {{ props.row.invoice.sellerInfo.companyName }}
        </span>
      </b-table-column>

      <b-table-column field="nf_serie" label="NF e Série" v-slot="props">
        <span class="adjust-top">
          {{ props.row.invoice.number }} - {{ props.row.invoice.series }}
        </span>
      </b-table-column>

      <b-table-column field="total" label="Total NF" v-slot="props">
        <span class="adjust-top">
          {{ props.row.merchant._id.payments.currencySymbol }}
          {{ formatMoney(props.row.invoice.totalNF) }}
        </span>
      </b-table-column>

      <b-table-column label="NF" v-slot="props">
        <button
          class="button"
          @click.stop="$emit('download-invoice', props.row)"
        >
          <b-icon icon="file-download"></b-icon>
        </button>
      </b-table-column>

      <template slot="empty">
        <table-empty-template />
      </template>

      <b-modal :active.sync="isPurchaseDetailVisible">
        <details-modal :purchase-invoice="selectedInvoice" />
      </b-modal>
    </b-table>
  </div>
</template>

<script>
import { common } from "../../../mixins/common";
import { mask } from "../../../mixins/mask";
import { mapGetters } from "vuex";
import tableEmptyTemplate from "../../common/TableEmptyTemplate";
import detailsModal from "./PurchasesDetailModal";

export default {
  mixins: [common, mask],

  props: ["purchasesInvoices", "showBuyer"],

  components: {
    tableEmptyTemplate,
    detailsModal
  },

  data() {
    return {
      isPurchaseDetailVisible: false,
      selectedInvoice: null
    };
  },

  methods: {
    loading(event) {
      this.$emit("is-loading", event);
    },

    showDetails(row) {
      this.selectedInvoice = row;
      this.isPurchaseDetailVisible = true;
    }
    // refund(transactionId) {
    //   this.transactionId = transactionId;
    //   this.isRefundModalVisible = true;
    // },
  },

  computed: {
    ...mapGetters(["preferences"])
  }
};
</script>

<style>
.adjust-top {
  position: relative;
  top: 8px;
}
</style>
